import React from "react";
import "./VipStats.css";

function VipStats({ Vip }) {
  return (
    <div className="vip_stats">
      <div className="stat_card">
        <h3 className="red_text">{Vip?.total_exp || 0} EXP</h3>
        <p>My experience</p>
      </div>

      <div className="stat_card">
        <h3>{Vip?.payout_days} Days</h3>
        <p>Payout time</p>
      </div>
    </div>
  );
}

export default VipStats;